import * as React from 'react'
import { useField, useFormikContext } from 'formik'

import { CollapsibleFilter } from './atoms'
import {
  type IOption,
  type LimitedDate,
  type IFilterProps,
  iOptionEqualityComparer,
} from '../typings'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'

interface Props extends IFilterProps {
  options: IOption[]
}

export function LimitedDateFilter(props: Props) {
  const { name, label, reset, options } = props

  const path = `filters.${name}.value`

  const { setFieldValue } = useFormikContext()
  const [{ value }] = useField<LimitedDate>(path)

  const onChange = React.useCallback(
    (_e: React.ChangeEvent<unknown>, value: IOption) =>
      setFieldValue(path, value),
    [path, setFieldValue],
  )

  return (
    <CollapsibleFilter
      label={label}
      reset={reset}
      subLabel={(expanded) => (!expanded && value ? value.label : '')}
    >
      <Autocomplete
        value={value}
        options={options}
        onChange={onChange}
        getOptionLabel={(o) => o.label}
        getOptionDisabled={(o) => o.disabled ?? false}
        isOptionEqualToValue={iOptionEqualityComparer}
        renderInput={(params) => (
          <TextField {...params} variant="standard" label={label} />
        )}
      />
    </CollapsibleFilter>
  )
}
